import { ImpactStyle } from '@capacitor/haptics';
import { hapticFeedback } from '@bridebook/web/lib/mobile-app/utils/haptic-feedback';

export const hapticFeedbackLight = async (): Promise<void> => hapticFeedback(ImpactStyle.Light);
